<div class="patient-status record-status-{{PatientRecordStatuses[patientRecordStatus].toLowerCase()}}" *ngIf="statusName" >
	<i   *ngIf="showIcon"  [class.selected]="selected" [ngClass]="iconClass" [attr.title]="statusName"></i>
	<div class="patient-status-name" *ngIf="showLabel">{{ statusName }}</div>
</div>
